<template>
    <span>
        <b-button class="align-baseline mr-1" title="Edit Property" :href="editPropertyHref" variant="default">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline mr-1"
            title="Regenerate Thumbnails"
            :disabled="regenerateDisabled"
            v-b-modal="regenerateModalId"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'image']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline" title="Delete Property" v-b-modal="deleteModalId" variant="default">
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal :id="regenerateModalId" title="Regenerate Thumbnails" @shown="onModalShown" @ok="regenerateThumbnails"
            >Regenerate thumbnails for {{ propertyName }}?</modal
        >
        <de-activation-modal
            :property-id="propertyId"
            :modal-id="deleteModalId"
            action="delete"
            @shown="onModalShown"
            @ok="deleteProperty"
        />
    </span>
</template>

<script>
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';
    import DeActivationModal from '../../common/de-activation-modal.vue';

    export default {
        components: {
            DeActivationModal,
            Modal,
        },
        data() {
            return {
                property: null,
                propertyId: 0,
                propertyName: 'this property',
                editPropertyHref: '',
                regenerateDisabled: false,
                regenerateModalId: '',
                deleteModalId: '',
            };
        },
        created() {
            this.property = this.params.data;
            this.propertyId = this.params.data.id;
            if (this.params.data.name) {
                this.propertyName = `"${this.params.data.name}"`;
            }
            // TODO: replace :href with :to
            // this.editPropertyHref = `/app/property/setup/details/${this.propertyId}/`;
            this.editPropertyHref = this.params.data.setup_link;
            this.regenerateDisabled = !this.params.data.can_regenerate_thumbnails;
            this.regenerateModalId = `modal-regenerate-property-${this.propertyId}`;
            this.deleteModalId = `modal-delete-property-${this.propertyId}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            async regenerateThumbnails() {
                this.regenerateDisabled = true;
                try {
                    await API.put(`/app/property/property/${this.propertyId}/`, {
                        regenerate_thumbnails: true,
                    });
                } catch (error) {
                    this.regenerateDisabled = false;
                    this.errorToast({ text: 'Could not regenerate thumbnails.' });
                    return;
                }
                this.successToast({ text: `Regenerating ${this.propertyName}.` });
            },
            async deleteProperty({ reason, reasonDetails }) {
                try {
                    await API.delete(`/app/property/property/${this.propertyId}/`, {
                        data: {
                            reason,
                            reason_details: reasonDetails,
                        },
                    });
                } catch (error) {
                    const response = error.response;
                    const detail = response && response.data && response.data.detail ? ' ' + response.data.detail : '';
                    this.errorToast({ text: `Could not delete property.${detail}` });
                    return;
                }
                this.params.api.applyTransaction({
                    remove: [this.params.node],
                });
            },
        },
    };
</script>
